import API from '@/api/index';

const language = {
  actions: {
    getLanguages ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.language
          .getLanguages(data)
          .then(response => {
            if (response.data) {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getLanguagesForMobile ({ state }) {
      return new Promise((resolve, reject) => {
        API.language.getLanguagesForMobile().then(response => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    updateLanguage ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.language.updateLanguage(data).then(response => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    getLanguageByKey ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.language.getLanguageByKey(data).then(response => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    updateLanguageDev ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.language
          .updateLanguageDev(data)
          .then((response) => {
            if (response.data) {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  }
};

export default language;



// WEBPACK FOOTER //
// ./src/store/modules/language.js